const PREFIX = '/v1/StateProject/StateProject'

export const URL = {
  ADD: PREFIX + '/add',
  DEL: PREFIX + '/delete',
  EDIT: PREFIX + '/edit',
  LIST: PREFIX + '/list',
  SIMPLE_LIST: PREFIX + '/listSimple',
  DETAIL: PREFIX + '/view',
  ENABLE: PREFIX + '/able',
  DISABLE: PREFIX + '/disable',
  ORDER: PREFIX + '/order',
  EXPORT: PREFIX + '/export',
  TONGJI: PREFIX + '/tongji',
  APPRAISAL_COMPANY_SET: PREFIX + '/xuandingpinggugongsi',
  HOME_ASSESSMENT_SET: PREFIX + '/ruhupinggu',
  PRE_ASSESSMENT_NOTICE_SET: PREFIX + '/yupinggugongshi',
  FUND_APPROVAL_SET: PREFIX + '/zijinqingpi',
  HOUSE_DEMOLITION_SET: PREFIX + '/fangwuchaichu',
  CERT_CANCEL_SET: PREFIX + '/chanzhengzhuxiao',
  CLOSURE_SET: PREFIX + '/jiexiang',
  PROCESS_SET: PREFIX + '/status',
  DATA_LIST: PREFIX + '/listData',
  VILLAGES_LIST: PREFIX + '/getProjectVillages'
}
